export const EXPERIMENT_NO_ADS = "noAds";
export const EXPERIMENT_USE_CUSTOM_HLS = "useCustomHls";
export const EXPERIMENT_FULLSCREEN_RECOMBEE = "005_recombee-full-screen-experiment";
export const EXPERIMENT_RECOMBEE_TRENDING_FEED = "003_recombee-trending-experiment";
export const EXPERIMENT_CLUTTER_FREE_PLAYER = "005-clutter-free-player-experiment";
export const EXPERIMENT_TRENDING_CURATION = "006-trending-curation-experiment";
export const EXPERIMENT_CONTEXT_BASED_RECOMMENDATIONS = "008-context-based-recommendations-experiment";

export const VARIANT_FS_RECOMBEE = "full-screen-recombee";
export const VARIANT_NON_FS_NON_RECOMBEE = "non-full-screen-non-recombee";
export const VARIANT_FS_RECOMBEE_FILTERED = "full-screen-recombee-filtered";

export const VARIANT_CONTROL = "control";
export const VARIANT_TREATMENT = "treatment";
export const VARIANT_OFF = "off";

export const VARIANT_CURATED = "curated";
export const VARIANT_POPULAR = "popular";
export const VARIANT_VERIFIED = "verified";
export const VARIANT_ESTABLISHED = "established";

export const EXPERIMENT_COVERAGE_MAP: {[key: string]: number} = {
  [EXPERIMENT_FULLSCREEN_RECOMBEE]: 0.27,
  [EXPERIMENT_RECOMBEE_TRENDING_FEED]: 0.54,
  [EXPERIMENT_CLUTTER_FREE_PLAYER]: 0.06,
  [EXPERIMENT_TRENDING_CURATION]: 0.06,
  [EXPERIMENT_CONTEXT_BASED_RECOMMENDATIONS]: 0.06,
};

export const FULLSCREEN_RECOMBEE_VARIANT_LIST = [
  {
    label: VARIANT_NON_FS_NON_RECOMBEE,
    value: VARIANT_NON_FS_NON_RECOMBEE
  },
  {
    label: VARIANT_FS_RECOMBEE,
    value: VARIANT_FS_RECOMBEE
  },
  {
    label: VARIANT_FS_RECOMBEE_FILTERED,
    value: VARIANT_FS_RECOMBEE_FILTERED
  }
];

export const RECOMBEE_TRENDING_FEED_VARIANT_LIST = [
  {
    label: VARIANT_TREATMENT,
    value: VARIANT_TREATMENT
  },
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];

export const CLUTTER_FREE_PLAYER_VARIANT_LIST = [
  {
    label: VARIANT_TREATMENT,
    value: VARIANT_TREATMENT
  },
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];

export const TRENDING_CURATION_VARIANT_LIST = [
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_CURATED,
    value: VARIANT_CURATED
  },
  {
    label: VARIANT_POPULAR,
    value: VARIANT_POPULAR
  },
  {
    label: VARIANT_VERIFIED,
    value: VARIANT_VERIFIED
  },
  {
    label: VARIANT_ESTABLISHED,
    value: VARIANT_ESTABLISHED
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];

export const CONTEXT_BASED_RECOMMENDATIONS_VARIANT_LIST = [
  {
    label: VARIANT_TREATMENT,
    value: VARIANT_TREATMENT
  },
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];
